module.exports = __webpack_public_path__ + "media/images/brand/favicon-06-17209e354d5b550a67a4decd27ec348d.png";